import React from "react";
import classnames from "classnames";
import {ReactComponent as SaveIcon} from "../../../../../assets/images/save-rollback/check.svg";
import {ReactComponent as CancelIcon} from "../../../../../assets/images/save-rollback/cancel.svg";
import {CircularProgress, Fade} from "@mui/material";

const ConfigurableInfoBlockFeedback = ({feedback, loading}) => {

    return (
        <>
            <Fade in={(feedback.show || loading)}>
                <div className={classnames('feedback', {
                    'loading': loading,
                    'success': !loading && feedback.success,
                    'error': !loading && !feedback.success
                })}>
                    {
                        loading ? <CircularProgress color={"secondary"} size={18}/>
                            : feedback.success === true
                                ? <SaveIcon/>
                                : feedback.success === false ?
                                    <CancelIcon/>
                                    : <CancelIcon className={'invisible'}/>
                    }
                    <p>
                        {
                            loading ? "loading..."
                                : feedback.success === true
                                    ? "Saved"
                                    : feedback.success === false ?
                                        "Error!"
                                        : <span className={'invisible'}>Error!</span>
                        }
                    </p>
                </div>
            </Fade>
        </>
    )
}

export default ConfigurableInfoBlockFeedback;
